module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Incoming-mail-d3e5e99a05076e2552cc2d0791dc68fa.svg";